module.exports = __webpack_public_path__ + "img/coinlist.b036016a.svg";